import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const routes = [
  {
    path: '/index',
    alias: '/',
    meta: {
      title: '五六公社',
    },
    component: ()=>import('@/views/index.vue')
  },
  {
    path: '/prize/list',
    meta: {
      title: '获奖公布',
    },
    component: ()=>import('@/views/prizeList.vue')
  },
  {
    path: '/prize/detail',
    meta: {
      title: '获奖公布',
    },
    component: ()=>import('@/views/prizeDetail.vue')
  },
  {
    path: '/caifeng/list',
    meta: {
      title: '摄影采风',
    },
    component: ()=>import('@/views/caifengList.vue')
  },
  {
    path: '/caifeng/detail',
    meta: {
      title: '摄影采风',
    },
    component: ()=>import('@/views/caifengDetail.vue')
  },
  {
    path: '/exhibition/list',
    meta: {
      title: '摄影展览',
    },
    component: ()=>import('@/views/exhibitionList.vue')
  },
  {
    path: '/exhibition/detail',
    meta: {
      title: '摄影展览',
    },
    component: ()=>import('@/views/exhibitionDetail.vue')
  },
  {
    path: '/course/list',
    meta: {
      title: '五六课堂',
    },
    component: ()=>import('@/views/courseList.vue')
  },
  {
    path: '/course/detail',
    meta: {
      title: '五六课堂',
    },
    component: ()=>import('@/views/courseDetail.vue')
  },
  {
    path: '/match/list',
    meta: {
      title: '自动投稿',
    },
    component: ()=>import('@/views/matchList.vue')
  },
  {
    path: '/ps/index',
    meta: {
      title: '人工精修',
    },
    component: ()=>import('@/views/psIndex.vue')
  },
  {
    path: '/ps/submit',
    meta: {
      title: '提交修图订单',
    },
    component: ()=>import('@/views/psSubmit.vue')
  },
  {
    path: '/ps/pack',
    meta: {
      title: '购买修图包',
    },
    component: ()=>import('@/views/psPack.vue')
  },
  {
    path: '/match/detail',
    meta: {
      title: '自动投稿',
    },
    component: ()=>import('@/views/matchDetail.vue')
  },
  {
    path: '/my/gallery',
    meta: {
      title: '我的图库',
    },
    component: ()=>import('@/views/myGallery.vue')
  },
  {
    path: '/my/awards',
    meta: {
      title: '获奖记录',
    },
    component: ()=>import('@/views/myAwards.vue')
  },
  {
    path: '/my/match',
    meta: {
      title: '我的投稿',
    },
    component: ()=>import('@/views/myMatch.vue')
  },
  {
    path: '/my/ps',
    meta: {
      title: '我的修图',
    },
    component: ()=>import('@/views/myPs.vue')
  },
  {
    path: '/my/psCheckOrder',
    meta: {
      title: '修图订单确认',
    },
    component: ()=>import('@/views/myPsCheckOrder.vue')
  },
  {
    path: '/my/psRepair/:userpsId/:orderNum',
    meta: {
      title: '修图订单确认',
    },
    component: ()=>import('@/views/myPsRepair.vue')
  },
  {
    path: '/my/order',
    meta: {
      title: '我的订单',
    },
    component: ()=>import('@/views/myOrder.vue')
  },
  {
    path: '/my/userinfo',
    meta: {
      title: '个人信息',
    },
    component: ()=>import('@/views/myUserinfo.vue')
  },
  {
    path: '/my/collects',
    meta: {
      title: '我的收藏',
    },
    component: ()=>import('@/views/myCollects.vue')
  },
  {
    path: '/my/coupons',
    meta: {
      title: '我的优惠券',
    },
    component: ()=>import('@/views/myCoupons.vue')
  },
  {
    path: '/agreement',
    meta: {
      title: '用户协议',
    },
    component: ()=>import('@/views/agreement.vue')
  },
  {
    path: '/my/members',
    meta: {
      title: '我的社员',
    },
    component: ()=>import('@/views/myMembers.vue')
  },
  {
    path: '/my/profit',
    meta: {
      title: '我的收益',
    },
    component: ()=>import('@/views/myProfit.vue')
  },
]

const router = new Router({
  mode: 'hash',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // 设置标题
  if (to.meta && to.meta.title) {
    window.document.title = to.meta.title;
  }
  let vuex_user = localStorage.getItem("vuex_user");
  //用户中心登录权限
  var checkRe = /^\/my\/(userinfo|gallery|awards|match|ps|order)/i;
  for (let i = 0; i < to.matched.length; i++) {
    if (to.matched[i].path.match(checkRe)) {
      if (!vuex_user || vuex_user == 'null') {
        return next("/index");
      }
    }
  }
  next();
});

export default router
